import { useState, FormEvent, KeyboardEvent } from 'react';

interface NameModalProps {
  onSubmit: (name: string) => void;
}

const NameModal: React.FC<NameModalProps> = ({ onSubmit }) => {
  const [name, setName] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = (e?: FormEvent) => {
    e?.preventDefault();
    
    const trimmedName = name.trim();
    
    if (!trimmedName) {
      setError(true);
      return;
    }
    
    // Save to localStorage
    localStorage.setItem('userName', trimmedName);
    
    // Call the onSubmit callback
    onSubmit(trimmedName);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  const handleInputChange = (value: string) => {
    setName(value);
    if (error) {
      setError(false);
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 animate-fadeIn"
      onClick={(e) => e.target === e.currentTarget && null} // Prevent closing on overlay click
    >
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-8 animate-slideUp">
        <h2 className="text-3xl font-bold text-gray-900 mb-2">
          Как вас зовут?
        </h2>
        <p className="text-gray-600 mb-6">
          Введите ваше имя, чтобы другие участники могли видеть ваши выборы
        </p>
        
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={name}
            onChange={(e) => handleInputChange(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Введите ваше имя"
            autoFocus
            className={`w-full px-4 py-3 border-2 rounded-lg text-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
              error 
                ? 'border-red-500 animate-shake' 
                : 'border-gray-300 focus:border-blue-500'
            }`}
            aria-label="Ваше имя"
            aria-invalid={error}
            aria-describedby={error ? 'name-error' : undefined}
          />
          
          {error && (
            <p 
              id="name-error" 
              className="text-red-500 text-sm mt-2 animate-slideDown"
              role="alert"
            >
              Пожалуйста, введите ваше имя
            </p>
          )}
          
          <button
            type="submit"
            className="w-full mt-6 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 transform hover:scale-[1.02] hover:shadow-lg active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            aria-label="Продолжить"
          >
            Продолжить
          </button>
        </form>
      </div>
    </div>
  );
};

export default NameModal;
